__turbopack_context__.v({
  "bars": "home-live-module__zbgUJa__bars",
  "blink": "home-live-module__zbgUJa__blink",
  "bold": "home-live-module__zbgUJa__bold",
  "bump": "home-live-module__zbgUJa__bump",
  "c1": "home-live-module__zbgUJa__c1",
  "c2": "home-live-module__zbgUJa__c2",
  "c3": "home-live-module__zbgUJa__c3",
  "ch": "home-live-module__zbgUJa__ch",
  "corners": "home-live-module__zbgUJa__corners",
  "countK": "home-live-module__zbgUJa__countK",
  "countV": "home-live-module__zbgUJa__countV",
  "counts": "home-live-module__zbgUJa__counts",
  "digitIn": "home-live-module__zbgUJa__digitIn",
  "eq": "home-live-module__zbgUJa__eq",
  "flipped": "home-live-module__zbgUJa__flipped",
  "head": "home-live-module__zbgUJa__head",
  "hero": "home-live-module__zbgUJa__hero",
  "heroSearch": "home-live-module__zbgUJa__heroSearch",
  "heroStage": "home-live-module__zbgUJa__heroStage",
  "heroTitle": "home-live-module__zbgUJa__heroTitle",
  "heroWord": "home-live-module__zbgUJa__heroWord",
  "isNew": "home-live-module__zbgUJa__isNew",
  "liveGrid": "home-live-module__zbgUJa__liveGrid",
  "logo": "home-live-module__zbgUJa__logo",
  "map": "home-live-module__zbgUJa__map",
  "merge": "home-live-module__zbgUJa__merge",
  "mono": "home-live-module__zbgUJa__mono",
  "narrow": "home-live-module__zbgUJa__narrow",
  "noanim": "home-live-module__zbgUJa__noanim",
  "none": "home-live-module__zbgUJa__none",
  "now": "home-live-module__zbgUJa__now",
  "odo": "home-live-module__zbgUJa__odo",
  "pad": "home-live-module__zbgUJa__pad",
  "root": "home-live-module__zbgUJa__root",
  "sName": "home-live-module__zbgUJa__sName",
  "searchHint": "home-live-module__zbgUJa__searchHint",
  "searchRow": "home-live-module__zbgUJa__searchRow",
  "section": "home-live-module__zbgUJa__section",
  "shot": "home-live-module__zbgUJa__shot",
  "showcase": "home-live-module__zbgUJa__showcase",
  "showcaseLink": "home-live-module__zbgUJa__showcaseLink",
  "side": "home-live-module__zbgUJa__side",
  "split": "home-live-module__zbgUJa__split",
  "sqLabel": "home-live-module__zbgUJa__sqLabel",
  "suggest": "home-live-module__zbgUJa__suggest",
  "tEvent": "home-live-module__zbgUJa__tEvent",
  "tLag": "home-live-module__zbgUJa__tLag",
  "tName": "home-live-module__zbgUJa__tName",
  "tTime": "home-live-module__zbgUJa__tTime",
  "ticker": "home-live-module__zbgUJa__ticker",
  "tickerFoot": "home-live-module__zbgUJa__tickerFoot",
  "tickerH": "home-live-module__zbgUJa__tickerH",
  "tin": "home-live-module__zbgUJa__tin",
  "vh": "home-live-module__zbgUJa__vh",
  "wide": "home-live-module__zbgUJa__wide",
  "wordmark": "home-live-module__zbgUJa__wordmark",
});
